import { render, staticRenderFns } from "./VideoHighlight.vue?vue&type=template&id=0f0c6d10&"
import script from "./VideoHighlight.vue?vue&type=script&lang=js&"
export * from "./VideoHighlight.vue?vue&type=script&lang=js&"
import style0 from "./VideoHighlight.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VideoHighlight.vue?vue&type=style&index=1&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCard,VCardActions,VCardText,VCol,VImg,VRow})
